export default function getChangeFieldName(type) {
  const changeTypes = {
    Borrower: 'borrower_id',
    Coborrower: 'coborrower_id',
    Agent: 'agent_id',
    Carrier: 'carrier_id',
    Broker: 'broker_id',
  };

  return changeTypes[type] || null;
}
